import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject, NgZone } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';


export const responseInterceptor: HttpInterceptorFn = (req, next) => {

  if(!req.url.includes(`${environment.API_ENDPOINT}`)){
    return next(req);
  }
  const ngZone = inject(NgZone);
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      console.log("interctor error mesage:", error);
      switch (error.status) {
        case 401:
          console.log("interceptor 401 error", error);
          ngZone.run(() => {
            window.location.href = '/login';
          });
          break;
        case 403:
          console.log("interceptor 403 error", error);
          ngZone.run(() => {
            window.location.href = '/logout';
          });
          break;
        // case 404:
        //   console.log("interceptor 404 error", error);
        //   ngZone.run(() => {
        //     window.location.href = '/not-found';
        //   });
        //   break;
        default:
          console.log("interceptor default error", error);
          break;
      };


      // if (error.status === 403 || error.status === 419) {

      //   console.log("interceptor navigate");
      //   ngZone.run(() => {
      //     window.location.href = '/logout';
      //   });
      // }

      return throwError(() => error);
    })
  );
};
